export default {
  translation: {
    common: {
      emailOrUsername: 'Е-пошта или корисничко име',
      invalidEmailOrUsername: 'Неисправна е-пошта или корисничко име',
      invalidCredentials: 'Неисправни акредитиви',
      invalidPassword: 'Неисправна лозинка',
      noInternetConnection: 'Нема конекције са интернетом',
      pageNotFound_title: 'Страница није пронађена',
      password: 'Лозинка',
      projectManagement: 'Управљање пројектима',
      serverConnectionFailed: 'Неуспешна конекција са сервером',
      unknownError: 'Непозната грешка, покушајте поново касније',
      useSingleSignOn: 'Користи универзалну пријаву',
    },

    action: {
      logIn: 'Пријава',
      logInWithSSO: 'Пријава са УП',
    },
  },
};
